var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.75V4.65015C6.75 3.81007 6.75 3.38972 6.91349 3.06885C7.0573 2.7866 7.2866 2.5573 7.56885 2.41349C7.88972 2.25 8.31007 2.25 9.15015 2.25H13.3501C14.1902 2.25 14.61 2.25 14.9309 2.41349C15.2132 2.5573 15.4429 2.7866 15.5867 3.06885C15.7502 3.38972 15.7502 3.80975 15.7502 4.64983V8.84985C15.7502 9.68993 15.7502 10.11 15.5867 10.4308C15.4429 10.7131 15.2129 10.9429 14.9307 11.0867C14.6101 11.25 14.1908 11.25 13.3523 11.25H11.25M6.75 6.75H4.65015C3.81007 6.75 3.38972 6.75 3.06885 6.91349C2.7866 7.0573 2.5573 7.2866 2.41349 7.56885C2.25 7.88972 2.25 8.31007 2.25 9.15015V13.3501C2.25 14.1902 2.25 14.61 2.41349 14.9309C2.5573 15.2132 2.7866 15.4429 3.06885 15.5867C3.3894 15.75 3.80924 15.75 4.64768 15.75H8.85266C9.6911 15.75 10.1104 15.75 10.4309 15.5867C10.7132 15.4429 10.9429 15.2129 11.0867 14.9307C11.25 14.6101 11.25 14.1908 11.25 13.3523V11.25M6.75 6.75H8.85015C9.69023 6.75 10.11 6.75 10.4309 6.91349C10.7132 7.0573 10.9429 7.2866 11.0867 7.56885C11.25 7.8894 11.25 8.30925 11.25 9.14771L11.25 11.25",
    stroke: "#586370",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.973c0df6ed57fdf503873f19d3ad5459.svg";
export { ForwardRef as ReactComponent };